/* ============================================================
   SKINDAE — skin quiz behaviour (deferred, delegated)
   Separate file so the PDP doesn't pay for homepage-only JS.
   ============================================================ */
(function () {
  'use strict';

  function stepEl(quiz, n) { return quiz.querySelector('[data-sk-step="' + n + '"]'); }

  function goto(quiz, n) {
    quiz.querySelectorAll('[data-sk-step]').forEach(function (s) {
      var match = s.getAttribute('data-sk-step') === String(n);
      s.hidden = !match;
      s.classList.toggle('on', match);
    });
    var bar = quiz.querySelector('[data-sk-quiz-bar]');
    if (bar) bar.style.width = (n === 1 ? 50 : n === 2 ? 85 : 100) + '%';
    var head = quiz.querySelector('.sk-quiz-meta');
    if (head) head.focus && head.focus();
  }

  function showResult(quiz) {
    var handle = quiz.getAttribute('data-answer-collection');
    var label = quiz.getAttribute('data-answer-label') || 'your skin';
    var blurb = quiz.getAttribute('data-answer-blurb') || '';
    var title = quiz.querySelector('[data-sk-result-title]');
    var blurbEl = quiz.querySelector('[data-sk-result-blurb]');
    var link = quiz.querySelector('[data-sk-result-link]');
    if (title) title.textContent = 'Built for ' + label.toLowerCase();
    if (blurbEl) blurbEl.textContent = blurb;
    if (link && handle) link.setAttribute('href', '/collections/' + handle);
    goto(quiz, 3);
  }

  document.addEventListener('click', function (e) {
    var quiz;

    var answer = e.target.closest('[data-sk-answer]');
    if (answer) {
      quiz = answer.closest('[data-sk-quiz]');
      if (!quiz) return;
      quiz.setAttribute('data-answer-collection', answer.getAttribute('data-collection') || '');
      quiz.setAttribute('data-answer-label', answer.getAttribute('data-label') || '');
      quiz.setAttribute('data-answer-blurb', answer.getAttribute('data-blurb') || '');
      goto(quiz, 2);
      return;
    }

    if (e.target.closest('[data-sk-quiz-back]')) {
      quiz = e.target.closest('[data-sk-quiz]');
      if (quiz) goto(quiz, 1);
      return;
    }

    if (e.target.closest('[data-sk-quiz-skip]')) {
      quiz = e.target.closest('[data-sk-quiz]');
      if (quiz) showResult(quiz);
      return;
    }

    if (e.target.closest('[data-sk-quiz-restart]')) {
      quiz = e.target.closest('[data-sk-quiz]');
      if (quiz) goto(quiz, 1);
      return;
    }
  });

  /* If the customer form posted successfully, jump straight to the result. */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-sk-quiz]').forEach(function (quiz) {
      if (quiz.querySelector('.sk-quiz-ok')) goto(quiz, 2);
    });
  });
})();
